import React from 'react';
import styled from '@emotion/styled';
import { h1Style } from './styles';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const H1Styled = styled.h1`
  ${h1Style};
`;

export default function H1(props: Props) {
  const { children, className } = props;
  return <H1Styled className={className}>{children}</H1Styled>;
}
